import styled from 'styled-components';
import {
  tablet_breakpoint,
  desktop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';
import Colors from 'pubweb-smokey/dist/colors';

export const CCPAFormStyles = styled.div`
  .ccpa-form-container {
    padding: 40px;
    p,
    h3,
    h5 {
      text-align: center;
    }

    .align-left {
      text-align: left;
    }
    .title-text {
      margin-top: 10px;
      margin-bottom: 20px;
    }
    .error-message {
      text-align: left;
    }
    form {
      margin-top: 30px;
      /* button {
                margin-top: 30px;
            } */
    }
    .request-type-text,
    .heading-text,
    .method-text {
      margin-top: 20px;
      text-align: left;
      padding: 0;
    }
    .request-type-text {
      font-weight: 600;
    }
    .thank-you-text {
      padding-bottom: 65px;
    }

    .request-error,
    .method-error,
    .details-error {
      color: ${Colors.accent.ladyBug.standard};
      margin-top: 10px;
      text-align: left;
    }
  }
  .method-buttons {
    margin-top: 10px;
  }
  a {
    cursor: pointer;
    text-decoration: none;
  }

  .close-to-title {
    margin-top: 4px !important;
  }
  .request {
    padding-top: 18px;
    padding-left: 4px;
  }

  .state-select-container {
    min-height: 72px;
    padding-top: 10px;
  }
  .open .dropdown-display {
    max-height: calc(75vh - 32px);
  }

  .ccpa-submit-button {
    margin-top: 20px;
  }

  @media only screen and (min-width: ${tablet_breakpoint}px) {
    .request {
      justify-content: space-between;

      .checkbox-component {
        width: 33%;
      }
    }
    .method {
      p {
        width: 33%;
      }
    }
  }

  @media only screen and (min-width: ${desktop_breakpoint}px) {
    padding-top: 0;

    .shared-form-row {
      display: flex;
      justify-content: space-between;

      > div {
        width: 48%;
      }
    }

    .request,
    .method {
      display: flex;
      flex-wrap: wrap;
    }
    .left {
      max-width: 40%;
    }

    .state-select-container {
      padding-top: 0;
    }
    .open .dropdown-display {
      max-height: 235px;
    }
  }
`;

export default CCPAFormStyles;
